import { GetEquipmentRefResponseSchema } from '@shared/schema/equipment-ref.get.schema'
import { queryOptions } from '@tanstack/react-query'

import { apiFetch } from '@/lib/api-fetch'

export const equipmentRefsQuery = queryOptions({
  queryKey: ['equipment-refs'],
  async queryFn() {
    const rawResponse = await apiFetch.get('equipment-ref')

    if (!rawResponse.ok) {
      throw new Error('Failed to fetch equipment refs')
    }

    try {
      return await GetEquipmentRefResponseSchema.parseAsync(await rawResponse.json())
    } catch (error) {
      throw new Error('Failed to parse equipment refs', { cause: error })
    }
  },
  staleTime: 1000 * 60 * 60 * 24, // 24 hours
})
